export * from './lib/virtual-trials-web.module';
